var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path3, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _path4, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path5, _rect27, _rect28, _rect29, _rect30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotesPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 209,
    viewBox: "0 0 204 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.54411,
    y: 0.823407,
    width: 125.501,
    height: 130.693,
    rx: 5.1076,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.54411,
    y: 0.823407,
    width: 125.501,
    height: 130.693,
    rx: 5.1076,
    stroke: "#EBEDF0",
    strokeWidth: 1.45931
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.418 30.8189V38.0259C74.418 38.7106 73.9175 39.2656 73.3004 39.2656H55.2855C54.6683 39.2656 54.168 38.7045 54.168 38.0063V23.0156H60.918C61.5393 23.0156 62.043 22.456 62.043 21.7656V14.2656H73.2949C73.9152 14.2656 74.418 14.8348 74.418 15.5054V20.2123L64.2943 31.4609L64.2873 36.7594L69.0645 36.7671L74.418 30.8189ZM75.2934 22.7751L76.8844 24.5429L68.1339 34.2656L66.5406 34.263L66.543 32.4979L75.2934 22.7751ZM54.168 20.5156L59.793 14.2696V20.5156H54.168Z",
    fill: "#4E4B66"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.8379,
    y: 47.6016,
    width: 56.9132,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4883,
    y: 68.0391,
    width: 103.611,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4883,
    y: 88.4688,
    width: 103.611,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4883,
    y: 108.898,
    width: 87.5588,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5441,
    y: 19.8234,
    width: 125.501,
    height: 130.693,
    rx: 5.1076,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5441,
    y: 19.8234,
    width: 125.501,
    height: 130.693,
    rx: 5.1076,
    stroke: "#EBEDF0",
    strokeWidth: 1.45931
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.418 49.8189V57.0259C93.418 57.7106 92.9175 58.2656 92.3004 58.2656H74.2855C73.6683 58.2656 73.168 57.7045 73.168 57.0063V42.0156H79.918C80.5393 42.0156 81.043 41.456 81.043 40.7656V33.2656H92.2949C92.9152 33.2656 93.418 33.8348 93.418 34.5054V39.2123L83.2943 50.4609L83.2873 55.7594L88.0645 55.7671L93.418 49.8189ZM94.2934 41.7751L95.8844 43.5429L87.1339 53.2656L85.5406 53.263L85.543 51.4979L94.2934 41.7751ZM73.168 39.5156L78.793 33.2696V39.5156H73.168Z",
    fill: "#4E4B66"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 54.8379,
    y: 66.6016,
    width: 56.9132,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4883,
    y: 87.0391,
    width: 103.611,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4883,
    y: 107.469,
    width: 103.611,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4883,
    y: 127.898,
    width: 87.5588,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5441,
    y: 38.8234,
    width: 125.501,
    height: 130.693,
    rx: 5.1076,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5441,
    y: 38.8234,
    width: 125.501,
    height: 130.693,
    rx: 5.1076,
    stroke: "#EBEDF0",
    strokeWidth: 1.45931
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.418 68.8189V76.0259C112.418 76.7106 111.917 77.2656 111.3 77.2656H93.2855C92.6683 77.2656 92.168 76.7045 92.168 76.0063V61.0156H98.918C99.5393 61.0156 100.043 60.456 100.043 59.7656V52.2656H111.295C111.915 52.2656 112.418 52.8348 112.418 53.5054V58.2123L102.294 69.4609L102.287 74.7594L107.065 74.7671L112.418 68.8189ZM113.293 60.7751L114.884 62.5429L106.134 72.2656L104.541 72.263L104.543 70.4979L113.293 60.7751ZM92.168 58.5156L97.793 52.2696V58.5156H92.168Z",
    fill: "#4E4B66"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 73.8379,
    y: 85.6016,
    width: 56.9132,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4883,
    y: 106.039,
    width: 103.611,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4883,
    y: 126.469,
    width: 103.611,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4883,
    y: 146.898,
    width: 87.5588,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5441,
    y: 57.8234,
    width: 125.501,
    height: 130.693,
    rx: 5.1076,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5441,
    y: 57.8234,
    width: 125.501,
    height: 130.693,
    rx: 5.1076,
    stroke: "#EBEDF0",
    strokeWidth: 1.45931
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.418 87.8189V95.0259C131.418 95.7106 130.917 96.2656 130.3 96.2656H112.286C111.668 96.2656 111.168 95.7045 111.168 95.0063V80.0156H117.918C118.539 80.0156 119.043 79.456 119.043 78.7656V71.2656H130.295C130.915 71.2656 131.418 71.8348 131.418 72.5054V77.2123L121.294 88.4609L121.287 93.7594L126.065 93.7671L131.418 87.8189ZM132.293 79.7751L133.884 81.5429L125.134 91.2656L123.541 91.263L123.543 89.4979L132.293 79.7751ZM111.168 77.5156L116.793 71.2696V77.5156H111.168Z",
    fill: "#4E4B66"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 92.8379,
    y: 104.602,
    width: 56.9132,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 69.4883,
    y: 125.039,
    width: 103.611,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 69.4883,
    y: 145.469,
    width: 103.611,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 69.4883,
    y: 165.898,
    width: 87.5588,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5441,
    y: 76.8234,
    width: 125.501,
    height: 130.693,
    rx: 5.1076,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5441,
    y: 76.8234,
    width: 125.501,
    height: 130.693,
    rx: 5.1076,
    stroke: "#EBEDF0",
    strokeWidth: 1.45931
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.418 106.819V114.026C150.418 114.711 149.917 115.266 149.3 115.266H131.286C130.668 115.266 130.168 114.705 130.168 114.006V99.0156H136.918C137.539 99.0156 138.043 98.456 138.043 97.7656V90.2656H149.295C149.915 90.2656 150.418 90.8348 150.418 91.5054V96.2123L140.294 107.461L140.287 112.759L145.065 112.767L150.418 106.819ZM151.293 98.7751L152.884 100.543L144.134 110.266L142.541 110.263L142.543 108.498L151.293 98.7751ZM130.168 96.5156L135.793 90.2696V96.5156H130.168Z",
    fill: "#4E4B66"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 111.838,
    y: 123.602,
    width: 56.9132,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 88.4883,
    y: 144.039,
    width: 103.611,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 88.4883,
    y: 164.469,
    width: 103.611,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 88.4883,
    y: 184.898,
    width: 87.5588,
    height: 11.6745,
    rx: 1.45931,
    fill: "#EBEDF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesPanel);
export default __webpack_public_path__ + "static/media/NotesPanel.b4a5354fc8489ebe075985a02a9b73bc.svg";
export { ForwardRef as ReactComponent };